<template>
  <article>
    <TopNav />
    <div class="section">
      <div class="container">
        <h3 class="title">Settings</h3>

        <div class="level">
          <div class="panel">
            <p class="panel-heading">Change Password</p>

            <div class="panel-block">
              <div class="section">
                <div class="field">
                  <label class="label">New Password</label>
                  <div class="control">
                    <input class="input" type="password" v-model="newPassword" placeholder="New Password">
                  </div>

                  <br>

                  <label class="label">Re-enter New Password</label>
                  <div class="control">
                    <input :class="getPwClass()" type="password" v-model="newPassword2" placeholder="One More Time...">
                  </div>
                </div>
                
                <br>

                <div class="field">
                  <div class="control">
                    <button class="button is-primary" @click="changePassword">Set New Password</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> <!-- /password -->

        <div class="level">
          <div class="panel">
            <p class="panel-heading">PagerDuty Integration</p>

            <div class="panel-block">
              <div class="section">
                <div class="field">
                  <label class="label">API Token</label>
                  <div class="control">
                    <input class="input" type="password" v-model="pagerDutyKey" placeholder="Token">
                  </div>
                </div>
                
                <br>

                <div class="field">
                  <div class="control">
                    <button class="button is-primary" @click="setPagerDutyKey">Enable</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> <!-- /pagerduty -->
      </div>
    </div>
  </article>
</template>

<script>
import { gql } from "apollo-boost";
import TopNav from "@/components/TopNav.vue";

export default {
  name: "Settings",
  components: {
    TopNav
  },
  data() {
    return {
      pagerDutyKey: "",
      newPassword: "",
      newPassword2: ""
    };
  },
  methods: {
    getPwClass() {
      return {
        input: true,
        "is-danger": this.newPassword != this.newPassword2
      };
    },
    changePassword() {
      if (this.newPassword != this.newPassword2) {
        return;
      }

      const pw = this.newPassword;
      this.newPassword = "";
      this.newPassword2 = "";

      this.$apollo.mutate({
        mutation: gql`
          mutation ($newPw: String!) {
            changePassword(newPassword: $newPw)
          }
        `,
        variables: {
          newPw: pw
        }
      }).then(() => {
        this.$toast.open({
          message: "Password Changed",
          type: "is-success"
        });
      }).catch(error => {
        console.log(error);
        this.$toast.open({
          message: error.message,
          type: "is-danger"
        });
      });
    },
    setPagerDutyKey() {
      if (this.pagerDutyKey === "") {
        return;
      }

      const key = this.pagerDutyKey;

      this.$apollo.mutate({
        mutation: gql`
          mutation ($pdConfig: PagerDutyConfig!) {
            addPagerDutyIntegration(pd: $pdConfig)
          }
        `,
        variables: {
          pdConfig: {
            key: key
          }
        }
      }).then(() => {
        this.$toast.open({
          message: "PagerDuty Enabled!",
          type: "is-success"
        });
      }).catch(error => {
        console.log(error);
        this.$toast.open({
          message: error.message,
          type: "is-danger"
        });
      });
    }
  }
};
</script>
